import VueGtag from 'vue-gtag';
import { Vue, router } from './startup';
import App from './App.vue';
import './quasar';
import store from './store';
import mixins from './mixins';

Vue.config.productionTip = false;
Vue.mixin(mixins);
if (process.env.VUE_APP_TAG !== '') {
  Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_TAG },
  }, router);
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
